module.exports = __webpack_public_path__ + "static/media/TransportationHospital.0da941a8.svg";